import ProductTransformer from './ProductTransformer';

export default class ProductOrderConfirmationTransformer extends ProductTransformer {
  static addFootnote(fn, product) {
    if (fn.name === 'footNoteConfirmation') {
      product.footnotes.push(fn.text);
    }
  }

  static parseFootnotes(product, footnotes) {
    ['productConfirmation', 'productConfirmationBeforeButtons', 'productConfirmationAfterButtons'].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
  }
}
